import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API call
export const fetchFoods = createAsyncThunk(
  "food/fetchFoods",
  async () => {
    const res = await fetch("https://dummyjson.com/recipes");
    const data = await res.json();
    return data.recipes; // ✅ important
  }
);

const foodSlice = createSlice({
  name: "food",
  initialState: {
    items: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFoods.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFoods.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchFoods.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default foodSlice.reducer;